import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import {
    Menu,
    MenuHandler,
    Button,
    MenuList,
    MenuItem,
    Checkbox, Input, Select, Option, Radio
} from '@material-tailwind/react'

export default function Search_Dropdown() {
    return (
        <div>
            <div className='flex items-center justify-center mt-[1.875rem] gap-[1.25rem] '>
                {/* search input  */}
                <div className='flex items-center justify-start 999:w-[600px] 600:w-[80vw] w-[70%] gap-[.9375rem] py-[.75rem] px-[1.375rem] rounded-[10px] border-[#E6E6E6] border'>
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none">
                            <path d="M19.9009 19.0992L16.5 15.7259C17.8201 14.0799 18.4594 11.9907 18.2864 9.88789C18.1135 7.78506 17.1414 5.82842 15.5701 4.42029C13.9988 3.01216 11.9477 2.25959 9.83855 2.3173C7.7294 2.37501 5.72253 3.23863 4.23058 4.73058C2.73863 6.22253 1.87501 8.2294 1.8173 10.3385C1.75959 12.4477 2.51217 14.4988 3.92029 16.0701C5.32842 17.6414 7.28506 18.6135 9.38789 18.7864C11.4907 18.9594 13.5799 18.3201 15.2259 17L18.5992 20.3734C18.6844 20.4593 18.7858 20.5275 18.8975 20.574C19.0092 20.6206 19.129 20.6445 19.25 20.6445C19.371 20.6445 19.4909 20.6206 19.6026 20.574C19.7143 20.5275 19.8157 20.4593 19.9009 20.3734C20.0661 20.2024 20.1584 19.974 20.1584 19.7363C20.1584 19.4986 20.0661 19.2701 19.9009 19.0992ZM10.0834 17C8.81427 17 7.57367 16.6237 6.51846 15.9186C5.46324 15.2136 4.6408 14.2114 4.15514 13.0389C3.66948 11.8664 3.54241 10.5762 3.79 9.33154C4.03758 8.08683 4.64871 6.94349 5.5461 6.0461C6.44349 5.14871 7.58683 4.53758 8.83154 4.29C10.0763 4.04241 11.3664 4.16948 12.5389 4.65514C13.7114 5.1408 14.7136 5.96324 15.4186 7.01846C16.1237 8.07367 16.5 9.31427 16.5 10.5834C16.5 12.2852 15.824 13.9173 14.6206 15.1206C13.4173 16.324 11.7852 17 10.0834 17Z" fill="#999CA4" />
                        </svg>
                    </div>
                    <Input
                        type="text"
                        placeholder="Search..."
                        className="!border-0  bg-white w-full !h-min  focus:!border-0  !leading-[29px] !p-0 focus:ring-none !text-[1.375rem] !font-light"
                        labelProps={{
                            className: "hidden",
                        }}
                        containerProps={{ className: "min-w-[100px]  !h-min" }}
                    />
                </div>
                {/* select  */}
                <div>
                    <div className='Label-after'>
                        <Select
                            className=' text-[1.125rem] font-[450] primary-text  leading-[29px] focus:outline-none focus:right-0 border-0 outline-0'
                            lockScroll={false}
                            label=''
                            containerProps={{ className: "!min-w-[auto] 1350:w-[15.8125rem] 999:w-[13rem] 600:w-[10rem] w-[30%] 600:block hidden !h-auto leading-[29px] py-[.75rem] px-[1.375rem] !border-[#E6E6E6] !border !rounded-[10px]" }}
                            animate={{
                                mount: { y: 0 },
                                unmount: { y: 25 },
                            }}
                            
                        >
                            <Option value='R-1' aria-selected Select >Recommended</Option>
                            <Option>Recommendeddd </Option>
                            <Option>Recommended dd</Option>
                        </Select>

                        <div className='600:hidden block'>
                            <Menu
                                dismiss={{
                                    itemPress: false,
                                }}
                            >
                                <MenuHandler className='bg-transparent !shadow-none'>
                                    <Button className='bg-transparent !shadow-none'>
                                        <svg className='bg-transparent' xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-sliders-horizontal">
                                            <line className='text-[#23232D] ' x1="21" x2="14" y1="4" y2="4" />
                                            <line className='text-[#23232D] ' x1="10" x2="3" y1="4" y2="4" />
                                            <line className='text-[#23232D] ' x1="21" x2="12" y1="12" y2="12" />
                                            <line className='text-[#23232D] ' x1="8" x2="3" y1="12" y2="12" />
                                            <line className='text-[#23232D] ' x1="21" x2="16" y1="20" y2="20" />
                                            <line className='text-[#23232D] ' x1="12" x2="3" y1="20" y2="20" />
                                            <line className='text-[#23232D] ' x1="14" x2="14" y1="2" y2="6" />
                                            <line className='text-[#23232D] ' x1="8" x2="8" y1="10" y2="14" />
                                            <line className='text-[#23232D] ' x1="16" x2="16" y1="18" y2="22" />
                                        </svg>
                                    </Button>
                                </MenuHandler>
                                <MenuList>
                                    <MenuItem className="p-0">
                                        <label
                                            htmlFor="item-1"
                                            className="flex cursor-pointer items-center gap-2 p-2"
                                        >
                                            <Radio
                                                name='option'
                                                ripple={false}
                                                id="item-1"
                                                containerProps={{ className: "p-0" }}
                                                className="hover:before:content-none"
                                            />
                                            Recommended
                                        </label>
                                    </MenuItem>
                                    <MenuItem className="p-0">
                                        <label
                                            htmlFor="item-2"
                                            className="flex cursor-pointer items-center gap-2 p-2"
                                        >
                                            <Radio
                                                name='option'
                                                ripple={false}
                                                id="item-2"
                                                containerProps={{ className: "p-0" }}
                                                className="hover:before:content-none"
                                            />
                                            Recommendedddd
                                        </label>
                                    </MenuItem>
                                    <MenuItem className="p-0">
                                        <label
                                            htmlFor="item-3"
                                            className="flex cursor-pointer items-center gap-2 p-2"
                                        >
                                            <Radio
                                                name='option'
                                                ripple={false}
                                                id="item-3"
                                                containerProps={{ className: "p-0" }}
                                                className="hover:before:content-none"
                                            />
                                            Recommendeda
                                        </label>
                                    </MenuItem>
                                </MenuList>
                            </Menu>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
